// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_app_name = /** @type {(inputs: {}) => string} */ () => {
	return `MochiMemo`
};

const id_app_name = /** @type {(inputs: {}) => string} */ () => {
	return `MochiMemo`
};

const ja_app_name = /** @type {(inputs: {}) => string} */ () => {
	return `もちメモ`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const app_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.app_name(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("app_name", locale)
	if (locale === "en") return en_app_name(inputs)
	if (locale === "id") return id_app_name(inputs)
	return ja_app_name(inputs)
};
export { app_name as "app.name" }